import React from 'react';
import { Inspector } from './Inspector';
import { TemplateMenu } from './TemplateMenu';
import { TreeView } from './TreeView';
import { Viewport } from './Viewport';
import SplitPane from 'react-split-pane';
export var SaucerEditor = React.memo(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(SplitPane, { split: "vertical", minSize: 180 },
            React.createElement(TemplateMenu, { cupNames: props.cupNames }),
            React.createElement(SplitPane, { split: "vertical", primary: "second", minSize: 240 },
                React.createElement(Viewport, null),
                React.createElement(SplitPane, { split: "horizontal", minSize: 240, pane2Style: { overflow: 'auto' } },
                    React.createElement(TreeView, null),
                    React.createElement(Inspector, null))))));
});
SaucerEditor.displayName = 'SaucerEditor';
